import { styled } from "@pigment-css/react";
import { BuildingSquare, ChevronRight } from "@acto/web-common/components";
import { MetaLabel } from "@acto/taskpane/field-sales-2/components/primitives/Card";

const HintRow = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[8],
  padding: 0,
  margin: 0,
  border: "none",
  background: "none",
  font: "inherit",
  textAlign: "left",
  "&:enabled": {
    cursor: "pointer",
  },
}));

const HintIcon = styled(BuildingSquare)(({ theme }) => ({
  color: theme.fieldSalesTwo.colors.charts.primary,
  flexShrink: 0,
}));

const HintLabel = styled(MetaLabel)({
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

const HintChevron = styled(ChevronRight)(({ theme }) => ({
  color: theme.fieldSalesTwo.colors.neutral[800],
  width: theme.fieldSalesTwo.spacing[12],
  height: theme.fieldSalesTwo.spacing[12],
  flexShrink: 0,
}));

interface CorporateGroupHintProps {
  label: string;
  /** When omitted, the chevron hides and the row is inert. */
  onOpenGroup?: () => void;
}

export function CorporateGroupHint({ label, onOpenGroup }: CorporateGroupHintProps) {
  return (
    <HintRow type="button" disabled={!onOpenGroup} onClick={onOpenGroup}>
      <HintIcon width={20} height={20} aria-hidden="true" />
      <HintLabel as="span">{label}</HintLabel>
      {onOpenGroup && <HintChevron aria-hidden="true" />}
    </HintRow>
  );
}
